/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  userDefaults: () => {
    return {
      uid: 0,
      displayName: "",
      about: "",
      photoURL: require("@/assets/images/portrait/small/avatar-s-11.jpg"),
      status: "online",
      userRole: "",
      phone: "",
      token: '',
      email: '',
      gender: '',
      birthdate: null,
      facebook: '',
      twitter: '',
      instagram: '',
      image: '',
      vat: '',
      addresses: []
    };
  },

  isUserLoggedIn: () => {
    let isAuthenticated = false;

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser;

    if (firebaseCurrentUser) isAuthenticated = true;
    else isAuthenticated = false;

    return localStorage.getItem('userInfo') && isAuthenticated;
  }
};
